import { PatientNote } from "../../features/patients/hooks/usePatientNotes";
import { BASE_URL } from "../Constants";


// Get all notes for a patient
export async function getPatientNotes (
    patientId: string,
    expertId: string,
    idToken: string,
): Promise<PatientNote[]> {
    const url = `${BASE_URL}/api/medical-user/patient-notes/patient/${patientId}/expert/${expertId}`;
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json',
        }
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error Response:', errorText);
        throw new Error(`Failed to fetch patient notes: ${response.status} ${response.statusText}`);
    }
    
    const responseText = await response.text();
    
    if (!responseText) {
        console.log('Empty response, returning empty array');
        return [];
    }
    
    try {
        const data = JSON.parse(responseText);
        return data;
    } catch (parseError) {
        console.error('JSON Parse Error:', parseError);
        console.error('Response text that failed to parse:', responseText);
        throw new Error('Invalid JSON response from server');
    }
};

// Add a new note
export async function addPatientNote (
    note: {
        patientId: string;
        expertId: string;
        text: string;
    },
    idToken: string,
): Promise<PatientNote> {
    console.log(note);
    const response = await fetch(`${BASE_URL}/api/medical-user/patient-notes`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            patient_id: note.patientId,
            expert_id: note.expertId,
            note: note.text
        }),
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('Add note error:', errorText);
        throw new Error('Failed to add patient note');
    }
    
    return response.json();
};

// Update an existing note
export const updatePatientNote = async (noteId: string, text: string, token: string): Promise<PatientNote> => {
    const response = await fetch(`${BASE_URL}/api/medical-user/patient-notes/${noteId}`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note: text }),
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('Update note error:', errorText);
        throw new Error('Failed to update patient note');
    }
    
    return response.json();
};

// Delete a note
export const deletePatientNote = async (noteId: string, token: string): Promise<void> => {
    const response = await fetch(`${BASE_URL}/api/medical-user/patient-notes/${noteId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('Delete note error:', errorText);
        throw new Error('Failed to delete patient note');
    }
};

// Additional endpoints you might want to use:
export const getPatientNoteById = async (noteId: string, token: string): Promise<PatientNote> => {
    const response = await fetch(`${BASE_URL}/api/patient-notes/${noteId}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    
    if (!response.ok) {
        throw new Error('Failed to fetch patient note');
    }
    
    return response.json();
};

export const getPatientNotesByExpert = async (expertId: string, token: string): Promise<PatientNote[]> => {
    const response = await fetch(`${BASE_URL}/api/patient-notes/expert/${expertId}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    
    if (!response.ok) {
        throw new Error('Failed to fetch expert notes');
    }
    
    return response.json();
}; 